import React from 'react'
import GitHubCalendar from "react-github-calendar";
import { Center, chakra, Image } from '@chakra-ui/react';
// const username= "avinash7488"

const GithubCalendar = () => {

  return (
    <div >
      <chakra.h1
            textAlign={'center'}
            fontSize={{base:"2xl",lg:"4xl"}}
            fontWeight={'bold'}
            bg={'teal'}
            color={'white'}
            w={{base:"80%",md:"60%",lg:"40%"}}
            h='50px'
            rounded="2xl"
            m={'auto'}
            mb={'50px'}
          >
          Contribution On GitHub
        </chakra.h1>
        <Center mt={10} mb={10} w={'full'} >
        
        <Image src="https://github-readme-stats.vercel.app/api?username=avinash7488&show_icons=true&theme=gruvbox" 
         alt="can't visible your github stats" w={{base:"90%",md:"70%",lg:"50%"}}/>
      </Center>
        
      <Center mt={10} mb={10} w={'full'} >
        <GitHubCalendar username="avinash7488" />
      </Center>
    </div>
  
  )
}

export default GithubCalendar;